import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray
} from "@angular/forms";
import { ActivatedRoute, Params } from "@angular/router";
import { Router } from "@angular/router";

@Component({
  selector: "app-usuarios-formulario",
  templateUrl: "./formulario.component.html"
})
export class FormularioComponent implements OnInit{
  dato: FormGroup;
  cambiarPassword: boolean = false;
  mostrarCambiarPassword: boolean = false;
  tab: number = 1;
  tab2: number = 0;
  tieneid: boolean = false;

  paises_id: number = null;
  estados_id: number = null;
  municipios_id: number = null;

  temp_paises_id: number = null;
  temp_estados_id: number = null;
  temp_municipios_id: number = null;

  form_sis_usuarios_contactos;
  form_sis_usuarios_rfcs;
  tamano;
  usuario;
  activar_super;

  empresa_sel = [];
  sucursal_sel = [];
  permisos_all: any[] = [];
  constructor(private fb: FormBuilder, private route: ActivatedRoute) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""],
      nombre: ["", [Validators.required]],
      email: ["", [Validators.required]],
      cambiarPassword: [false, []],
      password: [{ value: "", disabled: true }, [Validators.required]],
      confirmarPassword: [{ value: "", disabled: true }, [Validators.required]],
      foto: [""],
      avatar: [""],
      username: [""],
      direccion: [""],
      colonia: [""],
      numero_exterior: [""],
      numero_interior: [""],
      spam: [""],
      es_super: [0],
      codigo_postal: [""],
      last_login: [""],
      activo: [""],
      paises_id: [""],
      estados_id: [""],
      municipios_id: [""],
      sis_usuarios_contactos: this.fb.array([]),
      sis_usuarios_rfcs: this.fb.array([]),
      sis_usuarios_empresas: this.fb.array([]),
      sis_usuarios_sucursales: this.fb.array([]),
      sis_usuarios_dashboards: this.fb.array([]),
      sis_usuarios_reportes: this.fb.array([]),
      sis_usuarios_grupos: this.fb.array([]),
      permisos: [""],
      permisos_grupos: [""]
    });

    this.form_sis_usuarios_contactos = {
      tipos_medios_id: ["1"],
      valor: ["", [Validators.required]]
    };

    this.form_sis_usuarios_rfcs = {
      tipo_persona: ["Fisica", [Validators.required]],
      rfc: ["", [Validators.required]],
      razon_social: ["", [Validators.required]],
      paises_id: [""],
      estados_id: [""],
      municipios_id: [""],
      localidad: [""],
      colonia: [""],
      calle: [""],
      numero_exterior: [""],
      numero_interior: [""],
      codigo_postal: [""],
      email: [""]
    };

    this.tamano = document.body.clientHeight;
    this.usuario = JSON.parse(localStorage.getItem("usuario"));
    this.activar_super = this.usuario.es_super;

    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
        this.mostrarCambiarPassword = true;
        setTimeout(() => {
          this.dato.controls["password"].setValue("");
        }, 2000);
      } else {
        this.toggleCambiarPassword();
      }
    });

    // permisos indi
    this.dato.controls.permisos_grupos.valueChanges.subscribe(val => {
      if (val) {
        if (this.dato.controls.permisos.value) {
          this.dato.controls.permisos.patchValue(
            JSON.parse(this.dato.controls.permisos.value)
          );
        }
      }
    });
    this.activar_super = JSON.parse(localStorage.getItem("usuario")).es_super;

    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }
  modificar_permisos_individuales() {
    if (this.dato.get("permisos").value == null) {
      this.dato.controls.permisos.patchValue(JSON.parse(this.dato.controls.permisos_grupos.value));
    }
    else if (this.dato.get("permisos").value != "") {
      this.dato.controls.permisos.patchValue("");
    } else {
      this.dato.controls.permisos.patchValue(JSON.parse(this.dato.controls.permisos_grupos.value));
    }
  }

  toggleCambiarPassword() {
    this.cambiarPassword = !this.cambiarPassword;
    this.dato.controls["password"].setValue("");
    if (this.cambiarPassword) {
      this.dato.get("password").enable();
      this.dato.get("confirmarPassword").enable();
    } else {
      this.dato.get("password").disable();
      this.dato.get("confirmarPassword").disable();
    }
  }

  limpiar_sucursales(empresas, user) {
    if (!this.empresa_sel[empresas.id]) {
      empresas.sucursales.forEach(element => {
        let i = 0;
        this.dato.get("sis_usuarios_sucursales").value.forEach(buscar => {
          if (buscar == element.id) {
            this.dato.get("sis_usuarios_sucursales").value.splice(i, 1);
          }
          i++;
        });
      });
    }
  }

  // permisos individuales

  todosAccion(padre, accion, modelo) {
    if (typeof this.dato.controls.permisos.value == "string") {
      this.dato.controls.permisos.patchValue(
        JSON.parse(this.dato.controls.permisos.value)
      );
    }
    if (!this.permisos_all[padre]) this.permisos_all[padre] = false;

    this.permisos_all[padre] = !this.permisos_all[padre];
    let valor = this.permisos_all[padre];

    accion.forEach(function (value, key) {
      if (!valor) {
        delete modelo.value[padre + "." + value.recurso];
      } else {
        modelo.value[padre + "." + value.recurso] = valor ? 1 : 0;
      }
    });
  }
  agregar_accion(clave) {
    if (this.dato.controls.permisos.value[clave])
      delete this.dato.controls.permisos.value[clave];
    else this.dato.controls.permisos.value[clave] = 1;
  }

  addEmpresa(valor, modelo) {
    modelo.push(
      this.fb.group({
        empresas_id: [valor.id, Validators.required]
      })
    );
  }
  addSucursal(valor, modelo) {
    modelo.push(
      this.fb.group({
        sucursales_id: [valor.id, Validators.required]
      })
    );
  }

  empresas_sucursales() {
    const usuario = this.dato.getRawValue();
    usuario.sis_usuarios_empresas.forEach(element => {
      this.empresa_sel[element.empresas_id] = true;
    });
    usuario.sis_usuarios_sucursales.forEach(element => {
      this.sucursal_sel[element.sucursales_id] = true;
    });
  }
}
